import React from 'react'
import ReactPaginate from 'react-paginate';

export default function Mypager({ initialPage, pages, setPage }) {
    console.log('Mypager render with page:', initialPage, pages);
    return (
        <div className='mypager'>
            <div
                className={initialPage === 1 ? 'disabled' : ''} onClick={() => {
                    setPage(1)

                }}>首页</div>
            <ReactPaginate
                nextLabel="下一页"
                previousLabel="上一页"
                breakLabel="..."
                marginPagesDisplayed={1}
                pageRangeDisplayed={3}
                containerClassName="pagination"
                pageClassName='page-btn'
                activeClassName='active'
                forcePage={initialPage - 1}
                hrefBuilder={(page) => `?page=${page + 1}`}
                pageCount={pages}
                onPageChange={(v) => { setPage(v.selected + 1) }}
            />
            <div className={initialPage === pages ? 'disabled' : ''} onClick={() => {
                setPage(pages)
            }}>尾页</div>
        </div>

    )
}
